import { render, staticRenderFns } from "./DeviceAbnormal.vue?vue&type=template&id=589492a4&scoped=true&"
import script from "./DeviceAbnormal.vue?vue&type=script&lang=js&"
export * from "./DeviceAbnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589492a4",
  null
  
)

export default component.exports